module.exports = __webpack_public_path__ + "static/media/4 Seats 5 Sides Rollarm (connected).0ebd0084.png";